import { RadioOption } from "./radio-option";
import { EXPORT_THEMES, type ExportTheme } from "./types";

/** Render only while a PDF is selected; CSV has no theme. */
export function PdfThemeSection({
  theme,
  onChange,
}: {
  theme: ExportTheme;
  onChange: (theme: ExportTheme) => void;
}) {
  return (
    <div className="flex flex-col gap-1.5 rounded-lg border border-border bg-muted p-2.5">
      <span className="text-sm text-foreground">PDF theme</span>
      <div role="radiogroup" aria-label="PDF theme" className="flex flex-col">
        {EXPORT_THEMES.map((option) => (
          <RadioOption
            key={option.value}
            label={option.label}
            description={option.description}
            selected={theme === option.value}
            onSelect={() => onChange(option.value)}
          />
        ))}
      </div>
    </div>
  );
}
